import { useMutation } from '@apollo/client/react';
import { Typography } from '@mui/material';
import React from 'react';

import OverwatchModal from '@/components/OverwatchModal';
import { UpdateScheduleDocument, ResourceScheduleStatusEnum } from '@/graphql/generated/graphql';

interface ConflictDetectedModalProps {
  handleClose: () => void;
  handleCancel: () => void;
  conflictingId: string;
}

const ConflictDetectedModal: React.FC<ConflictDetectedModalProps> = ({ handleClose, handleCancel, conflictingId }) => {
  const [update] = useMutation(UpdateScheduleDocument);

  const handleDestroy = () => {
    update({
      variables: {
        schedule: {
          id: conflictingId,
          status: ResourceScheduleStatusEnum.Dropped,
        },
      },
      refetchQueries: ['getReportForSelectedDate'],
      onCompleted: () => handleCancel(),
    });
  };

  return (
    <OverwatchModal
      size="sm"
      title="Conflicts Detected"
      handleClose={handleClose}
      primaryButtonText="Proceed"
      primaryButtonAction={handleClose}
      secondaryButtonText="Cancel"
      secondaryButtonAction={handleDestroy}
    >
      <Typography sx={{ mb: 1 }}>One or more conflicting schedule was detected against your input.</Typography>
      <Typography>Are you sure you want to proceed or would you like to reschedule?</Typography>
    </OverwatchModal>
  );
};

export default ConflictDetectedModal;
